import React from 'react';
import PropTypes from 'prop-types';
import autoCompleteTeamHOC from '../../hoc/autoCompleteTeamHOC';
import AutoComplete from 'material-ui/AutoComplete';

const AutoCompleteTeam = ({ searchText, data: teams, handleOnClose, handleUpdateInput, onNewRequest }) => (
    <AutoComplete
        floatingLabelText="Team name"
        fullWidth
        openOnFocus
        searchText={searchText}
        filter={AutoComplete.fuzzyFilter}
        dataSource={teams}
        dataSourceConfig={{ text: 'name', value: 'id' }}
        onClose={handleOnClose}
        onUpdateInput={handleUpdateInput}
        onNewRequest={onNewRequest}
        maxSearchResults={5}
    />
);

AutoCompleteTeam.propTypes = {
    searchText: PropTypes.string,
    data: PropTypes.array.isRequired,
    onNewRequest: PropTypes.func.isRequired,
    handleOnClose: PropTypes.func.isRequired,
    handleUpdateInput: PropTypes.func.isRequired,
};

export default autoCompleteTeamHOC(AutoCompleteTeam);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/TeamPicker/AutoCompleteTeam.js
 **/